import gql from 'graphql-tag';

export default gql`
  fragment questionnaireResponse on QuestionnaireResponse {
    fhir
    id
    patientId
    questionnaireId
    status
    questionnaireResponseItems {
      definition
      id
      position
      questionnaireItemId
      questionnaireResponseId
      text
      questionnaireResponseItemAnswers {
        questionnaireAnswerId
        questionnaireResponseItemId
        value
        valueType
      }
    }
  }
`;
